/* NewEden2.0 — seamless marquee (gap-free infinite loop) */
(function () {
  'use strict';

  var resizeTimer;
  var ROOT_SELECTOR = '[data-trust-marquee], [data-scrolling-marquee]';

  function getMarqueeElements(root) {
    return {
      viewport: root.querySelector('[data-marquee-viewport], [data-trust-marquee-viewport]'),
      track: root.querySelector('[data-marquee-track], [data-trust-marquee-track]'),
      source: root.querySelector('[data-marquee-group], [data-trust-marquee-group]')
    };
  }

  function initMarquee(root) {
    var els = getMarqueeElements(root);
    var viewport = els.viewport;
    var track = els.track;
    var source = els.source;
    if (!viewport || !track || !source) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var speed = parseFloat(root.getAttribute('data-speed') || '30');
    var seed = source.cloneNode(true);

    track.innerHTML = '';
    track.classList.remove('is-ready');
    track.style.removeProperty('--marquee-distance');
    track.style.removeProperty('--marquee-duration');
    track.appendChild(seed);

    var cycleWidth = seed.getBoundingClientRect().width;
    if (cycleWidth <= 0) return;

    var minWidth = Math.max(viewport.getBoundingClientRect().width * 2, cycleWidth * 2);
    while (track.scrollWidth < minWidth) {
      track.appendChild(seed.cloneNode(true));
    }

    track.style.setProperty('--marquee-distance', cycleWidth + 'px');
    track.style.setProperty('--marquee-duration', speed + 's');

    if (!reduced) track.classList.add('is-ready');
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initMarquee);
  }

  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initAll, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector(ROOT_SELECTOR);
    if (el) initMarquee(el);
  });

  window.addEventListener('resize', onResize);
  window.addEventListener('load', initAll);
})();
